/**
 * Structured comparison data for the regulatory comparison table.
 * Keyed by ISO-2 country code. The `status` field is NOT included here —
 * it is read from the main country data (SAMPLE/Supabase) at runtime.
 *
 * Start: 5 countries (US, CN, IN, AU, BR). Others added incrementally.
 */

const COMPARISON_DATA = {
  US: {
    classification: 'property',
    legalTender: 'no',
    dedicatedLaw: 'in progress',
    primaryRegulator: 'SEC, CFTC, FinCEN',
    vaspLicensing: 'yes',
    capitalGainsTax: 'ordinary rates',
    taxableEvents: 'Selling, swapping, spending, exchange',
    airdropTaxed: 'yes',
    miningStakingTaxed: 'yes',
    stablecoinRegulation: 'yes',
    defiAddressed: 'partially',
    privacyTokensBanned: 'no',
    govAcceptsCrypto: 'no',
    bankIntegration: 'allowed',
    cbdcStatus: 'none',
    travelRule: 'yes',
  },
  CN: {
    classification: 'virtual asset',
    legalTender: 'no',
    dedicatedLaw: 'yes',
    primaryRegulator: 'PBOC, CSRC, CAC',
    vaspLicensing: 'no',
    capitalGainsTax: 'none',
    taxableEvents: 'All crypto banned — N/A',
    airdropTaxed: 'no',
    miningStakingTaxed: 'no',
    stablecoinRegulation: 'yes',
    defiAddressed: 'no',
    privacyTokensBanned: 'yes',
    govAcceptsCrypto: 'no',
    bankIntegration: 'prohibited',
    cbdcStatus: 'live',
    travelRule: 'no',
  },
  IN: {
    classification: 'virtual asset',
    legalTender: 'no',
    dedicatedLaw: 'no',
    primaryRegulator: 'FIU-IND, SEBI, RBI',
    vaspLicensing: 'yes',
    capitalGainsTax: '30%',
    taxableEvents: 'Selling, swapping, spending; 1% TDS on all transfers',
    airdropTaxed: 'yes',
    miningStakingTaxed: 'yes',
    stablecoinRegulation: 'no',
    defiAddressed: 'no',
    privacyTokensBanned: 'no',
    govAcceptsCrypto: 'no',
    bankIntegration: 'neutral',
    cbdcStatus: 'pilot',
    travelRule: 'partial',
  },
  AU: {
    classification: 'property',
    legalTender: 'no',
    dedicatedLaw: 'yes',
    primaryRegulator: 'ASIC, AUSTRAC',
    vaspLicensing: 'yes',
    capitalGainsTax: 'ordinary rates',
    taxableEvents: 'Selling, swapping, spending, gifting; 50% CGT discount if held >12mo',
    airdropTaxed: 'yes',
    miningStakingTaxed: 'yes',
    stablecoinRegulation: 'pending',
    defiAddressed: 'no',
    privacyTokensBanned: 'no',
    govAcceptsCrypto: 'no',
    bankIntegration: 'allowed',
    cbdcStatus: 'research',
    travelRule: 'yes',
  },
  BR: {
    classification: 'virtual asset',
    legalTender: 'no',
    dedicatedLaw: 'yes',
    primaryRegulator: 'BCB, CVM',
    vaspLicensing: 'yes',
    capitalGainsTax: '15%',
    taxableEvents: 'Selling, swapping, exchange; exempt if <R$35K/month',
    airdropTaxed: 'unclear',
    miningStakingTaxed: 'yes',
    stablecoinRegulation: 'pending',
    defiAddressed: 'no',
    privacyTokensBanned: 'no',
    govAcceptsCrypto: 'no',
    bankIntegration: 'allowed',
    cbdcStatus: 'pilot',
    travelRule: 'yes',
  },
};

export default COMPARISON_DATA;
